// src/i18n.js

export const t = {
  es: {
    // Header / hero
    hero_title: 'LIR Council: evaluación exclusiva de artículos legales',
    hero_sub: 'Plataforma privada de retroalimentación profesional',


    //seccioncomentario
    comment: 'Comentario',
    comment_optional: '(opcional)',
    placeholder_section_comment: 'Escribe un comentario sobre este articulo', 
    comment_personal_sensibility: ' No incluyas datos personales o sensibles.',
    suggestionarticle: 'Por favor, comparta sugerencias claras, objetivas y constructivas sobre el artículo, manteniendo siempre el respeto y la profesionalidad en sus comentarios.',

    // ClaveForm
    enter_key: 'Ingresa la clave única',
    check_email: 'Encuentra la clave única en tu correo',
    key_placeholder: 'Clave recibida por correo',
    access: 'Acceder',
    loading: 'Accediendo…',
    error_empty_key: 'Ingresa tu clave.',
    error_invalid_key: 'Clave no válida o no encontrada.',

    // 🆕 Burbuja de agradecimiento
    member_thanks_title: 'Muchas gracias por ser parte de LIR Council',
    member_thanks_body:
      'En esta plataforma, encontrarás los próximos artículos a evaluar. Para entrar, por favor ingresa la clave única que está en tu correo.',

    // ArticulosList
    loading_articles: 'Cargando artículos…',
    error_fetch_articles: 'Error al obtener artículos.',
    error_submit: 'Error al enviar respuestas.',
    must_rate_all: 'Debe calificar todos los artículos antes de enviar.',
    ready_to_send: 'Listo para enviar',
    send_ratings: 'Enviar calificaciones',
    sending: 'Enviando…',
    select_rating: 'Seleccione una calificación',
    welcome: 'Bienvenido',
    greet_m: 'Bienvenido',
    greet_f: 'Bienvenida',
    progress: 'Progreso',
    remaining: 'Faltan',
    of: 'de',

    // 🆕 ArticulosList: controles, estados y panel
    show_answers: 'Ver respuestas',
    hide_answers: 'Ocultar respuestas',
    sync: 'Sincronizar',
    syncing: 'Sincronizando…',
    prev: 'Anterior',
    next: 'Siguiente',
    logout: 'Cerrar sesión',
    select_articles: 'Seleccionar artículos',
    saved: 'Guardado',
    saving: 'Guardando…',
    retry_later: 'Error',
    current_answers: 'Respuestas actuales',
    close: 'Cerrar',
    rating: 'Calificación',
    missing: 'Sin calificar',
    go_to: 'Ir a',
    pagination: 'Paginación',
    error_submit_single: 'No se pudo guardar una calificación. Reintentaremos al enviar.',

    // Selección de artículos
    select_articles_title: 'Selecciona artículos',
    select_articles_hint: '(Selecciona solo los que deseas evaluar)',
    save: 'Guardar',

    // Confirmacion
    confirm_title: '¡Gracias por tu evaluación!',
    confirm_sub: 'Tus respuestas fueron registradas correctamente.',
    back: 'Volver',
    view_answers: 'Ver respuestas',

    // Opciones de calificación
    ratings: ['Outstanding', 'Excellent', 'Very Good', 'Espacio en blanco'],
    
    // Comentarios
    comment_label: 'Comentario',
    comment_placeholder: 'Escribe aquí tus comentarios o sugerencias sobre este artículo (opcional)',

    //select articulos
    select_all : 'Seleccionar todo',
    unselect_all : 'Deseleccionar todo',
    selected : 'Seleccionado',
    available : 'Disponible',

    //area
    area : 'Área',

    //no hay articulos
    no_articles : 'No hay artículos disponibles.',
    error_fetch_articles_hint : 'Puedes cerrar sesión o volver a intentar más tarde.',
  },

  en: {
    // Header / hero
    hero_title: 'LIR Council: Exclusive evaluation of legal articles',
    hero_sub: 'Private platform for professional feedback',


       //seccioncomentario
    comment: 'Comment',
    comment_optional: '(optional)',
    placeholder_section_comment: 'Write a comment about this article.', 
    comment_personal_sensibility: ' Do not include personal or sensitive information.',
    suggestionarticle: 'Please share clear, objective, and constructive suggestions about the article, always maintaining respect and professionalism in your comments.',


    // ClaveForm
    enter_key: 'Enter the unique password',
    check_email: 'Find the unique password in your email',
    key_placeholder: 'Password received by email',
    access: 'Log in',
    loading: 'Signing in…',
    error_empty_key: 'Enter your key.',
    error_invalid_key: 'Invalid or not found password.',

    // 🆕 Thank-you bubble
    member_thanks_title: 'Thank you very much for being part of LIR Council.',
    member_thanks_body:
      'On this platform, you will find upcoming articles up for review. To Log in, please enter the unique password found in your email.',

    // ArticulosList
    loading_articles: 'Loading articles…',
    error_fetch_articles: 'Error fetching articles.',
    error_submit: 'Error submitting responses.',
    must_rate_all: 'You must rate all articles before submitting.',
    ready_to_send: 'Ready to send',
    send_ratings: 'Submit rating',
    sending: 'Sending…',
    select_rating: 'Select a rating',
    welcome: 'Welcome',
    greet_m: 'Welcome',
    greet_f: 'Welcome',
    progress: 'Progress',
    remaining: 'Left',
    of: 'of',

    // 🆕 ArticulosList: controls, statuses & panel
    show_answers: 'See answers',
    hide_answers: 'Hide answers',
    sync: 'Sync',
    syncing: 'Syncing…',
    prev: 'Previous',
    next: 'Next',
    logout: 'Log out',
    select_articles: 'Select articles',
    saved: 'Saved',
    saving: 'Saving…',
    retry_later: 'Error',
    current_answers: 'Current answers',
    close: 'Close',
    rating: 'Rating',
    missing: 'Not rated',
    go_to: 'Go to',
    pagination: 'Pagination',
    error_submit_single: "Couldn't save a rating. We'll retry on submit.",

    // Select articles
    select_articles_title: 'Select article',
    select_articles_hint: '(Select only those you wish to evaluate)',
    save: 'Save',


    // Confirmacion
    confirm_title: 'Thank you for your review!',
    confirm_sub: 'Your answers were submitted correctly.',
    back: 'Return',
    view_answers: 'View answers',

    // Rating options
    ratings: ['Outstanding', 'Excellent', 'Very Good', 'Leave fill blank'],
    
    // Comments
    comment_label: 'Comment',
    comment_placeholder: 'Write here any comments or suggestions about this article (optional)',

    //select articulos
    select_all : 'Select all',
    unselect_all : 'Unselect all',
    selected : 'Selected',
    available : 'Available',

    //area
    area : 'Area',

    //no hay articulos
    no_articles : 'No articles available for reading.',
    error_fetch_articles_hint : 'You can log out or try again later.',
  },
};
